import { useEffect } from 'react';

import { formatValue } from 'containers/DataValidationModal/components/helpers';
import useApplicantUpdateDetail from 'hooks/useApplicantUpdateDetail';

import { FieldProps } from '../Field';

export const HiddenField = ({
  applicantId,
  detail,
  preventStoreUpdates,
  savePayload,
  type,
  updateApplicantDisabled,
}: FieldProps) => {
  const { updateApplicantDetail } = useApplicantUpdateDetail(
    applicantId,
    type,
    preventStoreUpdates,
  );

  useEffect(() => {
    if (!detail?.key || typeof detail.hidden_value === 'undefined') return;

    const payload = {
      ...(type && {
        [type]: {
          [detail.key]: formatValue(detail, detail.hidden_value) as string,
        },
      }),
    };

    if (updateApplicantDisabled) {
      savePayload(payload);
    } else {
      void updateApplicantDetail(payload);
    }
  }, [
    applicantId,
    detail?.key,
    detail?.hidden_value,
    detail,
    preventStoreUpdates,
    savePayload,
    type,
    updateApplicantDetail,
    updateApplicantDisabled,
  ]);

  return null;
};
